export const EXSBSETTLEMENT_CREATE_RESET = 'EXSBSETTLEMENT_CREATE_RESET'
export const EXSBSETTLEMENT_CREATE_SET_CREATED = 'EXSBSETTLEMENT_CREATE_SET_CREATED'
export const EXSBSETTLEMENT_CREATE_SET_ERROR = 'EXSBSETTLEMENT_CREATE_SET_ERROR'
export const EXSBSETTLEMENT_CREATE_SET_VIOLATIONS = 'EXSBSETTLEMENT_CREATE_SET_VIOLATIONS'
export const EXSBSETTLEMENT_CREATE_TOGGLE_LOADING = 'EXSBSETTLEMENT_CREATE_TOGGLE_LOADING'
